import type { BezoekAanSpecialistOption } from '@common/enums';
import type { YesNoNoDeviations } from '@common/enums/yesNoDeviations';
import type { Icd10CodeGroup } from '@common/interfaces/api/icd10Api';
import type { HolterDeviations } from './deviationUtils';

export enum HolterConclusionOption {
    afwijkend = 'Afwijkend',
    alarmerend_afwijkend = 'Alarmerend afwijkend',
    borderline = 'Borderline',
    niet_te_beoordelen = 'Niet te beoordelen',
    normaal = 'Normaal',
    variant_van_normaal = 'Variant van normaal',
}

export const holterConclusionOptions: HolterConclusionOption[] = [
    HolterConclusionOption.normaal,
    HolterConclusionOption.variant_van_normaal,
    HolterConclusionOption.borderline,
    HolterConclusionOption.afwijkend,
    HolterConclusionOption.alarmerend_afwijkend,
    HolterConclusionOption.niet_te_beoordelen,
];

export type HolterConsultData = {
    additionalFindings: string | null;
    additionalFollowUp: string | null;
    conclusion: HolterConclusionOption | null;
    deviations: HolterDeviations;
    hasDiagnosis: YesNoNoDeviations | null;
    policy: string | null;
    visitSpecialist: BezoekAanSpecialistOption | null;
    workDiagnosis: Icd10CodeGroup | null;
};
export enum HolterGradingAdvice {
    aanvullend_slaaponderzoek_naar_osas_viaKsyos = 'Aanvullend slaaponderzoek naar OSAS via Ksyos',
    geen_opvolging_noodzakelijk = 'Geen opvolging noodzakelijk',
    geruststellen_expectatief_beleid = 'Geruststellen / expectatief beleid',
    opvolgend_teleconsult_cardioloog_via_ksyos = 'Opvolgend teleconsult cardioloog via Ksyos',
    spoed_verwijs_patient_naar_eerste_harthulp = 'Spoed, verwijs patiënt naar eerste (hart)hulp',
    verwijzing_polikliniek_cardiologie = 'Verwijzing polikliniek cardiologie',
}

export const holterGradingAdviceOptions: HolterGradingAdvice[] = [
    HolterGradingAdvice.geen_opvolging_noodzakelijk,
    HolterGradingAdvice.geruststellen_expectatief_beleid,
    HolterGradingAdvice.aanvullend_slaaponderzoek_naar_osas_viaKsyos,
    HolterGradingAdvice.opvolgend_teleconsult_cardioloog_via_ksyos,
    HolterGradingAdvice.verwijzing_polikliniek_cardiologie,
    HolterGradingAdvice.spoed_verwijs_patient_naar_eerste_harthulp,
];

export enum HolterGradingRelationEcgAndComplaints {
    de_patient_heeft_geen_klachten_genoteerd = 'De patiënt heeft geen klachten genoteerd',
    er_zijn_ecg_afwijkingen_echter_niet_gerelateerd_aan_klachten_namelijk = 'Er zijn ECG afwijkingen, echter niet gerelateerd aan klachten, namelijk',
    geen_bruikbaar_dagboek = 'Geen (bruikbaar) dagboek',
    tijdens_klachten_worden_atriale_en_ventriculaire_ectopie_gezien = 'Tijdens klachten worden atriale en ventriculaire ectopie gezien',
    tijdens_klachten_worden_ecg_afwijkingen_gezien_namelijk = 'Tijdens klachten worden ECG afwijkingen gezien, namelijk',
    tijdens_klachten_worden_geen_ecg_afwijkingen_gezien = 'Tijdens klachten worden geen ECG afwijkingen gezien',
    tijdens_klachten_wordt_atriale_ectopie_gezien = 'Tijdens klachten wordt atriale ectopie gezien',
    tijdens_klachten_wordt_sinustachycardie = 'Tijdens klachten wordt sinustachycardie gezien',
    tijdens_klachten_wordt_ventriculaire_ectopie_gezien = 'Tijdens klachten wordt ventriculaire ectopie gezien',
}

export const holterGradingRelatieEcgEnKlachtenOptions: HolterGradingRelationEcgAndComplaints[] = [
    HolterGradingRelationEcgAndComplaints.de_patient_heeft_geen_klachten_genoteerd,
    HolterGradingRelationEcgAndComplaints.er_zijn_ecg_afwijkingen_echter_niet_gerelateerd_aan_klachten_namelijk,
    HolterGradingRelationEcgAndComplaints.geen_bruikbaar_dagboek,
    HolterGradingRelationEcgAndComplaints.tijdens_klachten_worden_atriale_en_ventriculaire_ectopie_gezien,
    HolterGradingRelationEcgAndComplaints.tijdens_klachten_worden_ecg_afwijkingen_gezien_namelijk,
    HolterGradingRelationEcgAndComplaints.tijdens_klachten_worden_geen_ecg_afwijkingen_gezien,
    HolterGradingRelationEcgAndComplaints.tijdens_klachten_wordt_atriale_ectopie_gezien,
    HolterGradingRelationEcgAndComplaints.tijdens_klachten_wordt_ventriculaire_ectopie_gezien,
    HolterGradingRelationEcgAndComplaints.tijdens_klachten_wordt_sinustachycardie,
];

export enum HolterGradingUrgency {
    binnen_een_dag = 'Binnen een dag',
    binnen_een_maand = 'Binnen een maand',
    binnen_een_week = 'Binnen een week',
    electieve_verwijzing = 'Electieve verwijzing',
}

export const holterGradingUrgencyOptions: HolterGradingUrgency[] = [
    HolterGradingUrgency.binnen_een_dag,
    HolterGradingUrgency.binnen_een_week,
    HolterGradingUrgency.binnen_een_maand,
    HolterGradingUrgency.electieve_verwijzing,
];
